import PubSub from "underpub-js";

/**
 * OverlayDark
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var VideoOverlay = function(options){

  this.options = {
    $el: false
  };
  
  $.extend(true, this.options, options);
  
  // video container
  this.$videoContainer = this.options.$el.find(".video-container");
  this.$videoIFrame = this.options.$el.find("iframe");
  this.parameters = JSON.parse(this.options.$el[0].dataset.videoOverlay);

  // console.log(this.$videoIFrame);

};

/**
 * Init
 * @return {[type]} [description]
 */
VideoOverlay.prototype.init = function(){

  var self = this;
  var isAutoplay = this.parameters?.isAutoplay ?? false;

  PubSub.subscribe("showVideoOverlay", function(options){

    self.$videoContainer.addClass("is-active");
    self.show();
    if(isAutoplay){
      self.autoplay();
    }

  });

  // closing the overlay on click
  this.options.$el.on("click", function(e){

    var $target = $(e.target);

    if(self.options.$el.is($target)){
      self.hide();
    }

  });

};

/**
 * Show
 * @return {[type]} [description]
 */
VideoOverlay.prototype.show = function(){

  this.options.$el.addClass("is-active");

};

/**
 * Hide
 * @return {[type]} [description]
 */
VideoOverlay.prototype.hide = function(){

  var self = this;

  this.options.$el.removeClass("is-active");
  this.$videoContainer.removeClass("is-active");
  
  var targetOrigin = 'https://www.youtube.com';
  if (this.$videoIFrame[0].src) {
    try {
      targetOrigin = new URL(this.$videoIFrame[0].src, window.location.origin).origin;
    } catch (e) {}
  }

  this.$videoIFrame[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', targetOrigin);

};

/**
 * Autoplay
 * add autoplay parameter if needed
 */
VideoOverlay.prototype.autoplay = function(){
  var self = this;
  var videoSrc = this.$videoIFrame[0].src;

  var isParameter = videoSrc.indexOf('?');
  var paramCharacter = isParameter !== 1 ? '&' : '?';
  this.$videoIFrame[0].src = videoSrc + paramCharacter + 'autoplay=1';
}

export default  VideoOverlay;
